import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { ReactComponent as ThreeDotsVertical } from "../../assets//images/threeDotVertical.svg";
import { ReactComponent as SubTaskIcon } from "../../assets/images/subTaskIcon.svg";
import { ReactComponent as ViewNotes } from "../../assets/images/ViewNotes.svg";
import { ReactComponent as FilterCross } from "../../assets/images/FilterCross.svg";
import { ReactComponent as ArchiveIcon } from "../../assets/images/icons/ArchiveIcon.svg";
import { ReactComponent as SearchBgIcon } from "../../assets/images/icons/SearchBg.svg";
import { ReactComponent as AddSubTaskDownArrow } from "../../assets/images/addSubTaskDownArrow.svg";
import { ReactComponent as GroupingBy } from "../../assets/images/GroupingBy.svg";
import { ReactComponent as StopGroup } from "../../assets/images/StopGrouping.svg";
import { ReactComponent as SortDecreasing } from "../../assets/images/SortDec.svg";
import { ReactComponent as SortIncreasing } from "../../assets/images/SortIncIcon.svg";
import { ReactComponent as RedDecreasing } from "../../assets/images/icons/RedDecreasing.svg";
import { ReactComponent as RedIncreasing } from "../../assets/images/icons/RedIncreasing.svg";
import { ReactComponent as PinIcon } from "../../assets/images/PinTo.svg";
import { ReactComponent as NewNoTaskIcon } from "../../assets/images/NewNoTaskIcon.svg";
import { ReactComponent as EditIcon } from "../../assets/images/editIconAdvancedFilter.svg";
import { ReactComponent as CrossIcon } from "../../assets/images/CrossIconGroupBy.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/deleteIconCoaTable.svg";
import { ReactComponent as ImportIcon } from "../../assets/images/icons/ImportIcon.svg";
import { ReactComponent as CloseModalImg } from "../../assets/images/Vector.svg";
import { ReactComponent as SubTaskIconOpen } from "../../assets/images/subTaskOpenIcon.svg";
import { ReactComponent as SubTaskIconClosed } from "../../assets/images/subtaskClosedIcon.svg";

import SearchIcon from "../../assets/images/icons/SearchIcon";
import FilterIcon from "../../assets/images/icons/FilterIcon";

import {
  useReactTable,
  getCoreRowModel,
  ColumnFiltersState,
  getPaginationRowModel,
  FilterFn,
  getSortedRowModel,
  getGroupedRowModel,
  getExpandedRowModel,
  flexRender,
  getFilteredRowModel,
  sortingFns,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
} from "@tanstack/react-table";
import { RiFileExcel2Line } from "react-icons/ri";
import { ReactComponent as DownloadIcon } from "../../assets/images/download_icon.svg";
import { RankingInfo, rankItem, compareItems } from "@tanstack/match-sorter-utils";
import RenderElements from "../GlobalFeature/Others/RenderElements";
import RenderElementsCopy from "../GlobalFeature/Others/RenderElementsCopy";
import useDataInputHandler from "../../hooks/Table/useTableTbodyFireCopy";
import TasListkModal from "../customer/TasListkModal";
import ViewNotesComponent from "../GlobalFeature/Table/ExtraComponent/ViewNotesComponent";
import { mkConfig, generateCsv, download } from "export-to-csv";
import { safeJsonParse, transformAndReorder } from "../../utils/utilityFunctions/stringUtility";
import { checkAccessPermission, getCompanyId } from "../../utils/utilityFunctions/localServices";
import SelectComponent from "./SelectComponent";
import ToolTipComponent from "./ToolTipComponent";
import SelectDropdown from "../Dropdown/SelectDropdown";
import { color } from "framer-motion";
import AdvancedFilterComponent from "./AdvancedFilterComponent";
import SettingsIconLeftPanel from "../../assets/images/SettingsIconLeftPanel";
// import ConfirmationDialog from "./ConfirmationDialogBox";
import { usePostMetaSaveMutation } from "../../utils/customer/customerListHeader";
import ConfirmationDialog from "./ConfirmationDialogMulti";
import BasicSelect from "../Task/BasicSelect";
import AlternateView from "./AlternateView";
import { useLocation, useParams } from "react-router-dom";
import { ReactComponent as ExcelICon } from "../../assets/images/ExcelIcon.svg";
import { ReactComponent as ClearGrouping } from "../../assets/images/icons/ClearGrouping.svg";
import { ReactComponent as ExpendAll } from "../../assets/images/icons/ExpendAll.svg";
import { ReactComponent as CollapseAll } from "../../assets/images/icons/CollapseAll.svg";
import { Sort } from "@mui/icons-material";
import { SortAscIcon, SortDescIcon } from "lucide-react";
import ImportPopupComponent from "./ImportPopupComponent";
import GetMappedTabs from "./getMappedTabs";
import { hexToRgba } from "../../utils/utilityFunctions/color";
import { buildOptionsFromList, findFirstKey } from "../../utils/utilityFunctions/CustomerReactTable/CustomerUtility";
import Filter, { DebouncedInput } from "../../utils/Filter/FilterUtil";
import { CircularProgress } from "@mui/material";

const csvConfig = mkConfig({
  fieldSeparator: ",",
  filename: "sample", // export file name (without .csv)
  decimalSeparator: ".",
  useKeysAsHeaders: true,
});

//multiselect

const keysToExclude = [
  "notes",
  "delegation",
  "tasks",
  "id",
  "org_id",
  "company_id",
  "customer_grp",
  "created_by",
  "created_at",
  "updated_at",
  "is_archived",
  "manage_at",
  "link_id",
  "s_level_parent_cust_id",
  "customer_profile_pic",
  "customer_profile_pic",
  "task_date",
  "profile_pic",
  "deal_date",
  "lead_date",
];

// Export function
const exportExcel = (rows, Headers, setExcelDownloadLoading) => {
  try {
    setExcelDownloadLoading(true);
    const keyMap = Object.fromEntries(Headers?.map((item) => [item.value, item.label]) || []);
    // console.log("Headersexcel", Headers);
    // console.log("rowsexcel", rows);

    // console.log("keyMapexcel", keyMap);

    const rowData = rows.map((row) => {
      //

      return Object.fromEntries(
        Object.entries(row.original)
          .filter(([key]) => keyMap.hasOwnProperty(key) && !keysToExclude?.includes(key))
          .map(([key, value]) => {
            const newKey = keyMap[key] ?? key;

            // if (typeof value === "object" && value !== null) {
            //   return ;
            // }

            try {
              const parsedValue = safeJsonParse(value);

              if (Array.isArray(parsedValue)) {
                return [
                  newKey,
                  parsedValue
                    .map((item) => item.value ?? "")
                    .filter(Boolean)
                    .join("; ") || "",
                ];
              }

              if (parsedValue && typeof parsedValue === "object" && "value" in parsedValue) {
                return [newKey, parsedValue.value ?? ""];
              }
            } catch (e) {}

            // return [newKey, value ?? ""];
            return [newKey, typeof value === "object" && value !== null ? JSON.stringify(value) : (value ?? "")];
          })
      );
    });
    // const exportEnabledData = transformAndReorder(rowData, ["delegation", "tasks"]);
    // const csv = generateCsv(csvConfig)(exportEnabledData);
    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
    //download(csvConfig)(csv);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
  } finally {
    setExcelDownloadLoading(false);
  }
};

const fuzzyFilter = (row, columnId, value, addMeta) => {
  // Rank the item
  const itemRank = rankItem(row.getValue(columnId), value);

  // Store the itemRank info (addMeta may not exist in plain JavaScript)
  if (addMeta) {
    addMeta({
      itemRank,
    });
  }

  // Return if the item should be filtered in/out
  return itemRank.passed;
};

const getCommonPinningStyles = (column, table, noMenuOpenList = [], defaultPinnedColumn) => {
  const isPinned = column.getIsPinned(); // 'left' | 'right' | false
  const isLastLeftPinnedColumn = isPinned === "left" && column.getIsLastColumn("left");
  const isFirstRightPinnedColumn = isPinned === "right" && column.getIsFirstColumn("right");

  // Helper: width with your override for noMenuOpenList
  const minWidthIds = ["subject"];

  const effectiveWidth = (col) => {
    let width = noMenuOpenList?.includes(col.id) ? 60 : col.getSize();
    if (minWidthIds.includes(col.id)) {
      width = Math.max(width, 300);
    }
    return width;
  };

  // Helper: compute offset for this column based on preceding pinned columns
  const computeOffset = (side) => {
    if (!side) return undefined;
    const pinnedCols = side === "left" ? table.getLeftLeafColumns() : table.getRightLeafColumns();

    let offset = 0;
    for (const c of pinnedCols) {
      if (c.id === column.id) break; // stop before current column
      offset += Number(effectiveWidth(c)) || 0;
    }
    return offset;
  };

  const side = isPinned === "left" ? "left" : isPinned === "right" ? "right" : null;
  const leftOffset = side === "left" ? computeOffset("left") : undefined;
  const rightOffset = side === "right" ? computeOffset("right") : undefined;

  return {
    boxShadow:
      isLastLeftPinnedColumn && column.id !== defaultPinnedColumn
        ? "-4px 0 4px -4px gray inset"
        : isFirstRightPinnedColumn
          ? "4px 0 4px -4px gray inset"
          : undefined,
    left: side === "left" ? `${leftOffset}px` : undefined,
    right: side === "right" ? `${rightOffset}px` : undefined,
    opacity: isPinned ? 3 : 1, // (kept as-is from your code)
    position: isPinned ? "sticky" : "relative",
    width: effectiveWidth(column), // 70px for ids in noMenuOpenList
    zIndex: isPinned ? 1 : 0,
  };
};

const CustomerReactTable = ({
  headers = [],
  body = [],
  tableName,
  tableDetail = {},
  fetchPersonInTable,
  rawHeaders,
  fetchtableBodyData,
  customerCommnData,
  refetchCustomerData,
  TableFieldUpdate = () => {},
  ExtraFields,
  MainFields,
  currentPage,
  setCurrentPage,
  taskId,
  isTaskDrawerOpen,
  closeTaskDrawer,
  taskClickCustomer,
  viewNotes,
  columnVisibility,
  setColumnVisibility = () => {},
  columnOrder,
  setColumnOrder,
  activeTab,
  view,
  totalCount,
  multiData,
  setMultiData,
  setResetPageIndex,
  resetPageIndex = true,
  grouping,
  setGrouping,
  handleReorderFields = () => {},
  isDrawerOpen,
  globalFilter,
  setGlobalFilter,
  noExcelDownload = true,
  leftPanel,
  isAdvancedFilterOpen,
  setIsAdvancedFilterOpen,
  metaData,
  refetchHeader,
  closeAdvancedFilter,
  noMenuOpenList,
  handleRowEditClick,
  excelDownload,
  isMySpace = false,
  isCustomModule = false,
  showColumnEdit = false,
  showColumnDelete = false,
  editColumnCallBack = () => {},
  deleteColumnCallBack = () => {},
  selectedRowId,
  otherComponent = <></>,
  setSelectedRowId = () => {},
  rowClickDisabled,
  disableSaveFilter,
  apiStates = {},
  alternateDivs,
  defaultPinnedColumn = "select",
  otherComponentView = false,
  isMySpaceCreateColumnHtml = () => {},
  isPostApiCall = false,
  dynamicScrollableTabs = false,
  metaPostData = () => {},
  isMetaApiCall = false,
  internalNavBar,
  kanbanSearchIcon = false,
  columnSearchTerms,
  setColumnSearchTerms,
  narrowHeader = false,
  sizingApiCall = false, //this is temporary, just for time being, till header api is not included in task table
  hiddenTableTopOuterInputs = true, //to hide the whole top outer div which contains search,filter,import,add new etc
  generateUniqueValues = () => {},
  useGenerateUniqueValues = false,
  buildOptionsFromList = () => {},
  useBuildOptionsFromList,
  TableDashboard = null,
  receiveMetaDataPayload = () => {},
  isViewSwitchable,
  compactViewSwitchButton,
  subtaskExpanded,
  setSubtaskExpanded,
  SubTaskClick = () => {},
  isSubtasKThere = false,
  hiddenAction = false,
}) => {
  console.log("compactViewSwitchButton", compactViewSwitchButton);
  const isInitialMount = useRef(true);

  const location = useLocation();
  const pathname = location.pathname;
  const storageKey = `${pathname}`;

  const handleItemSearch = (e, columnKey) => {
    const value = e.target.value;
    // setColumnSearchTerms((prev) => ({
    //   ...prev,
    //   [columnKey]: value,
    // }));

    setColumnSearchTerms(value);
  };

  const handleSearchItemClear = (columnKey) => {
    // setColumnSearchTerms((prev) => ({
    //   ...prev,
    //   [columnKey]: "",
    // }));

    setColumnSearchTerms("");
  };

  const BackgroundColorMatch = (value) => {
    switch (value.toLowerCase()) {
      case "not started":
        return "#0E8BFE";
      case "work in progress" || "In Progress":
        return "#F16136";

      case "completed":
        return "#008937";

      case "hold":
        return "#EE950F";
      case "drop":
        return "#9A0D94";

      case "cancelled":
        return "#BC1203";
      default:
        return "bg-gray-500";
    }
  };

  // const [sorting, setSorting] = React.useState([]);
  const [sorting, setSorting] = useState(() => {
    try {
      if (metaData?.field_management?.sorting && metaData?.sorting?.length > 0) {
        return metaData?.field_management?.sorting;
      }

      const saved = localStorage.getItem(`${storageKey}-SortOrder`);
      return saved ? safeJsonParse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    if (!isInitialMount.current) {
      const payload = {
        field_management: {
          sorting: sorting?.length > 0 ? sorting : null,
        },
      };

      if (isMetaApiCall) {
        // if (metaData?.field_management?.sorting !== sorting){  receiveMetaDataPayload(payload);}
        if (
          metaData?.field_management?.sorting !== null &&
          sorting?.length !== 0 &&
          metaData?.field_management?.sorting !== sorting
        ) {
          receiveMetaDataPayload(payload);
        }
      } else {
        if (sorting?.length > 0) {
          localStorage.setItem(`${storageKey}-SortOrder`, JSON.stringify(sorting));
        } else {
          localStorage.removeItem(`${storageKey}-SortOrder`);
        }
      }
    } else isInitialMount.current = false;
  }, [sorting]);

  const [columnFilters, setColumnFilters] = useState(() => {
    try {
      if (metaData?.filter_management?.column_filters && metaData?.filter_management?.column_filters?.length > 0) {
        return metaData?.filter_management?.column_filters;
      }

      // otherwise fall back to localStorage
      const saved = localStorage.getItem(`${storageKey}-ColumnFilters`);
      console.log("inside try but else", saved);
      return saved ? safeJsonParse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    console.log("inside column filters use effect", columnFilters);
    if (!isInitialMount.current) {
      const payload = {
        filter_management: {
          column_filters: columnFilters?.length > 0 ? columnFilters : null,
        },
      };

      console.log("payload for columnfilter", payload);

      if (isMetaApiCall && metaData) {
        if (
          //commented below, as i could remember why this was added, need to check later on
          // metaData?.filter_management?.column_filters !== null &&
          // columnFilters?.length !== 0 &&
          metaData?.filter_management?.column_filters !== columnFilters
        )
          receiveMetaDataPayload(payload);
      } else {
        if ((columnFilters?.length > 0) & !isAdvancedFilterOpen) {
          localStorage.setItem(`${storageKey}-ColumnFilters`, JSON.stringify(columnFilters));
        } else {
          localStorage.removeItem(`${storageKey}-ColumnFilters`);
        }
      }
    } else isInitialMount.current = false;
  }, [columnFilters]);

  //new api post for columnfilters

  useEffect(() => {
    setIsFilterActive(columnFilters.length > 0 && !isAdvancedFilterOpen);
  }, [columnFilters]);

  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [scrollbarWidth, setScrollbarWidth] = useState("100%");
  const [activeCell, setActiveCell] = useState({ rowId: null, columnId: null });
  const [isSearchActive, setIsSearchActive] = useState(null);
  const [clientCoord, setClientCoord] = useState({});
  const [rowSelection, setRowSelection] = React.useState({});
  const [isHovered, setIsHovered] = useState(false);
  const [isFilterHovered, setIsFilterHovered] = useState(false);
  const [draggedColumn, setDraggedColumn] = useState(null);

  const [allExpanded, setAllExpanded] = useState(false);

  const [showConfirmationAdvancedFilter, setShowConfirmationAdvancedFilter] = useState(false);
  const [showConfirmationFilter, setShowConfirmationFilter] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isImportPopupOpen, setIsImportPopupOpen] = useState(false);

  const [excelDownloadLoading, setExcelDownloadLoading] = useState(false);

  const handleImportClick = () => {
    setIsImportPopupOpen(true);
  };

  const [columnSizing, setColumnSizing] = useState(() => {
    // const saved = localStorage.getItem(`${tableDetail?.tableName}ColumnSizing`);
    // return saved ? JSON.parse(saved) : {};
    const sizing = metaData?.field_management?.column_sizing
      ? safeJsonParse(metaData?.field_management?.column_sizing)
      : {};

    return sizing;
  });

  const columnSizingRef = useRef(columnSizing);

  // Keep ref in sync with state
  useEffect(() => {
    columnSizingRef.current = columnSizing;
  }, [columnSizing]);

  useEffect(() => {
    if (metaData?.field_management?.column_sizing) {
      // console.log("ins1234", metaData?.columnSizing);

      // const parsed = JSON.parse(metaData.columnSizing);
      setColumnSizing(metaData?.field_management?.column_sizing);
    }
  }, [metaData]);

  const handleRenderElementRowKey = (rowId, columnId) => {
    setActiveCell((prevActiveCell) => {
      // If the clicked cell is already active, reset activeCell
      if (prevActiveCell.rowId === rowId && prevActiveCell.columnId === columnId) {
        return { rowId: null, columnId: null }; // Reset state
      }
      // Otherwise, update to the new active cell
      return { rowId, columnId };
    });
  };

  const handleAdvancedFilterClickConfirmation = () => {
    if (isAdvancedFilterOpen) {
      table.resetColumnFilters();
      setIsAdvancedFilterOpen(false);
    } else if (isFilterActive) {
      setShowConfirmationAdvancedFilter(true);
    } else {
      setIsAdvancedFilterOpen(true);
    }
  };

  const handleAdvancedFilterClick = () => {
    setShowConfirmationAdvancedFilter(false);
    table.setColumnFilters([]);
    setIsFilterActive(false);
    setIsAdvancedFilterOpen(true);
  };

  const handleFilterClick = () => {
    table.resetColumnFilters();
    setIsAdvancedFilterOpen(false);
    setIsFilterActive(true);
    setShowConfirmationFilter(false);
  };

  const handleDragStart = (column) => {
    setDraggedColumn(column);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    if (draggedColumn) {
      setGrouping((prev) => [...prev, draggedColumn.id]);
    }
    // setDraggedColumn(null);
  };
  const handleReorder = (e, column) => {
    handleReorderFields(draggedColumn.getIndex() - 1, column.getIndex() - 1);
  };

  // const handleRowClick = (id) => {
  //   //console.log("handleRowClick")

  //   if (selectedRowId?.includes(id)) {
  //     return;
  //   }
  //   if (multiData) {
  //     setMultiData({});
  //   }

  //   setSelectedRowId([id]);
  // };
  const handleRowClick = () => {};
  const { handleDataInput } = useDataInputHandler(fetchtableBodyData, setActiveCell, setClientCoord);

  const handleOtherDetailChange = (header, item, columnKey, event) => {
    if ((activeCell && Object.values(activeCell).some((value) => value !== null)) || isNaN(header)) {
      return;
    }
    handleDataInput(header, item, columnKey, event);
  };

  const updateTableField = (e, item, completedata, cell, originalvalue) => {
    //commented the e.stoppropagation for now as it was causing some roor
    // e.stopPropagation();
    setActiveCell((prevActiveCell) => {
      // If the clicked cell is already active, reset activeCell

      return { rowId: null, columnId: null }; // Reset state
    });

    TableFieldUpdate(item, completedata, cell, originalvalue);
  };

  const toggleSearchIcon = () => {
    setIsSearchActive((prevState) => !prevState);
    setGlobalFilter("");
  };

  useEffect(() => {
    if (!isSearchActive) {
      setIsHovered(false);
    }
  }, [isSearchActive]);

  const toggleFilterActive = () => {
    if (isFilterActive) {
      //identifier
      // table.resetColumnFilters();
      setColumnFilters([]);
      setIsFilterActive(false);
    } else if (!isAdvancedFilterOpen) {
      setIsFilterActive(true);
    } else {
      setShowConfirmationFilter(true);
    }

    // setIsFilterActive((prevState) => {
    //   if (prevState) {
    //     table.resetColumnFilters(); // Reset filter value when turning off the filter
    //   }
    //   return !prevState;
    // });
  };

  useEffect(() => {
    if (!isFilterActive) {
      setIsFilterHovered(false);
    }
  }, [isFilterActive]);

  const handleScroll = (direction) => {
    if (scrollbarWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value to control the scroll speed
      const currentScroll = scrollbarWrapperRef.current.scrollLeft;

      // Correct scrolling logic based on direction
      if (direction === "next") {
        // Scroll right (increase scrollLeft)
        scrollbarWrapperRef.current.scrollLeft = currentScroll + scrollAmount;
      } else if (direction === "previous") {
        // Scroll left (decrease scrollLeft), but don't go below 0
        scrollbarWrapperRef.current.scrollLeft = Math.max(currentScroll - scrollAmount, 0);
      }
    }
  };

  //to set the scrollbar to the left side when grouping is applied or removed
  useEffect(() => {
    if (scrollbarWrapperRef.current) {
      scrollbarWrapperRef.current.scrollLeft = 0;
    }
  }, [grouping]);

  const toggleDropdown = (headerId) => {
    setOpenDropdownId((prevId) => (prevId === headerId ? null : headerId));
  };

  const handleSort = (header, order) => {
    table.setSorting([
      {
        id: header.column.id, // Column ID to sort
        desc: order === "desc", // true for descending, false for ascending
      },
    ]);
  };

  const removeGrouping = (item) => {
    setGrouping((prev) => prev.filter((group) => group !== item)); // Remove the ungrouped column from the grouping array.

    setColumnVisibility((prevVisibility) => ({
      ...prevVisibility,
      [item]: true,
    }));
    setOpenDropdownId(null);
  };

  const handlePin = (table, header) => {
    const columnId = header.column.id;

    const pinnedState = table.getState().columnPinning;

    const isPinned =
      (pinnedState.left && pinnedState.left?.includes(columnId)) ||
      (pinnedState.right && pinnedState.right?.includes(columnId));

    if (!isPinned) {
      table.setColumnPinning({
        left: [...pinnedState.left, columnId],
        //left: [columnId],

        right: [],
      });
    } else {
      table.setColumnPinning({
        left: pinnedState.left.filter((id) => id !== columnId),
        // left: [],
        right: pinnedState.right,
      });
    }
  };

  // const [open, setOpen] = useState(false);
  // const [dropUp, setDropUp] = useState(false);

  // const pageSizes = [25, 50, 100];
  const pageSizes = [
    { label: "25", value: 25 },
    { label: "50", value: 50 },
    { label: "100", value: 100 },
  ];

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setOpen(false);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  // useEffect(() => {
  //   if (open && dropdownRef.current) {
  //     const rect = dropdownRef.current.getBoundingClientRect();
  //     const windowHeight = window.innerHeight;

  //     if (rect.bottom + 100 > windowHeight) {
  //       setDropUp(true);
  //     } else {
  //       setDropUp(false);
  //     }
  //   }
  // }, [open]);

  const child1Ref = useRef(null);
  const tableRef = useRef(null);
  const scrollbarWrapperRef = useRef(null);
  const paginationRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleOutsideClick(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && openDropdownId) {
        console.log("Clicked outside of dropdown");
        setOpenDropdownId(null);
      }
    }

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [openDropdownId]);

  const table = useReactTable({
    data: useMemo(() => body, [body]) || [],
    columns: headers || [],
    defaultColumn: {
      minSize: 20,
      maxSize: 600,
    },

    // getSubRows: (row) => row?.sub_tasks || [],
    //getSubRows,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    initialState: {
      pagination: {
        pageSize: 25,
      },
    },
    state: {
      sorting,
      grouping,
      columnFilters,
      globalFilter,
      columnOrder,
      columnVisibility,
      columnSizing,
      // rowSelection,
      // columnOrder,
    },
    // state: {
    //   grouping,
    // },
    columnResizeMode: "onChange",
    columnResizeDirection: "rtl",
    onColumnSizingChange: setColumnSizing,
    onGlobalFilterChange: setGlobalFilter,

    globalFilterFn: (row, columnId, value) => {
      return String(row.getValue(columnId)).toLowerCase().includes(value.toLowerCase());
    }, //apply fuzzy filter to the global filter (most common use case for fuzzy filter)
    // globalFilterFn: "fuzzy",

    onColumnFiltersChange: setColumnFilters,
    onGroupingChange: setGrouping,
    getExpandedRowModel: getExpandedRowModel(),
    getGroupedRowModel: grouping ? getGroupedRowModel() : null,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    onSortingChange: setSorting,
    getFacetedRowModel: getFacetedRowModel(), // client-side faceting
    getFacetedUniqueValues: getFacetedUniqueValues(),
    autoResetPageIndex: resetPageIndex,
    debugTable: true,
    enableColumnResizing: true,
    autoResetExpanded: false,
    //groupedColumnMode:false
    // onSortingChange: setSorting,
    // onGroupingChange: setGrouping,
    // onColumnVisibilityChange: setColumnVisibility,
    // onRowSelectionChange: setRowSelection,
    // columnOrder,
    // getCoreRowModel: getCoreRowModel(), // Handles rows without pagination
    // // getSortedRowModel: getSortedRowModel(), // Sorting rows
    // getExpandedRowModel: getExpandedRowModel(),
    // getGroupedRowModel: getGroupedRowModel(), // Grouping rows
    //getSubRows: (row) => row.sub_tasks, // Link sub-tasks to subRows
    // onExpandedChange: setExpanded,
    enableColumnResizing: true,
  });

  const handleClearAllGrouping = () => {
    setColumnVisibility((prevVisibility) => {
      const updatedVisibility = { ...prevVisibility };

      grouping.forEach((item) => {
        updatedVisibility[item] = true;
      });

      return updatedVisibility;
    });

    setGrouping([]);
  };

  useEffect(() => {
    const pinnedState = table.getState().columnPinning;
    // const columnId = "select";

    const isAlreadyPinnedLeft = pinnedState.left && pinnedState.left.includes(defaultPinnedColumn);

    if (!isAlreadyPinnedLeft) {
      table.setColumnPinning({
        left: [defaultPinnedColumn, ...(pinnedState.left || [])],
        right: pinnedState.right || [],
      });
    }
  });

  useEffect(() => {
    setActiveCell({ rowId: null, columnId: null });
  }, [table.getFilteredRowModel()?.rows?.length]);

  const pageNumbers = useMemo(() => {
    const totalPages = table.getPageCount();
    const currentPage = table.getState().pagination.pageIndex + 1;

    const pages = [];

    if (totalPages <= 6) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      if (currentPage > 4) {
        pages.push("..."); // Ellipsis for pages before the current range
      }

      for (let i = Math.max(2, currentPage - 2); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 3) {
        pages.push("..."); // Ellipsis for pages after the current range
      }

      pages.push(totalPages);
    }

    return pages;
  }, [table.getPageCount(), table.getState().pagination.pageIndex]);

  const [tableWidth, setTableWidth] = useState(table.getTotalSize());

  const [lastColWidth, setLastColWidth] = useState(() => {
    const cols = table.getVisibleLeafColumns();
    return cols[cols?.length - 1]?.getSize() ?? 0;
  });

  useEffect(() => {
    if (table.getRowModel()?.rows?.length > 0) {
      const cols = table.getVisibleLeafColumns();
      const last = cols[cols?.length - 1];
      setTimeout(() => {
        if (last) {
          setLastColWidth(last.getSize());
        }
      }, 0);
    }
  }, [table.getRowModel()?.rows?.length]);

  //earlier we were setting the columnsizing in our local storage, no we are posting it into our header api,

  // useEffect(() => {
  //   // localStorage.setItem(`${tableDetail?.tableName}ColumnSizing`, JSON.stringify(columnSizing));
  //   const response = await postFilterSave({ columnSizing }).unwrap();

  // }, [columnSizing]);

  useLayoutEffect(() => {
    setTableWidth(table.getTotalSize());
    const visibleColumns = table.getVisibleLeafColumns();
    const lastColumn = visibleColumns[visibleColumns?.length - 1];
    const newWidth = lastColumn?.getSize() ?? 0;
    if (newWidth !== lastColWidth) {
      setLastColWidth(newWidth);
      handleScroll("next");
    }
  }, [table.getState().columnSizing, table.getTotalSize(), activeCell]);

  // useEffect(() => {
  //   setTableWidth(table.getTotalSize());

  // },[ view?.view_name])

  useEffect(() => {
    // Calculate the total width of the table
    if (tableRef.current) {
      const tableWidth = tableRef.current.scrollWidth;
      const containerWidth = child1Ref.current.clientWidth;

      if (tableWidth > containerWidth + 20) {
        setScrollbarWidth(`${tableWidth}px`);
      } else {
        setScrollbarWidth("0px");
      }

      // setScrollbarWidth(`${tableWidth}px`);
    }
  }, [body, view, columnVisibility, tableWidth, table.getRowModel().rows.length, activeCell]);
  const bgRef = useRef([]);

  useEffect(() => {
    const shadowStyle = "-4px 0 4px -4px gray inset";
    const child1 = child1Ref.current;

    const scrollbarWrapper = scrollbarWrapperRef.current;
    if (child1 && scrollbarWrapper) {
      const handleScroll = () => {
        if (child1.scrollLeft !== scrollbarWrapper.scrollLeft) {
          child1.scrollLeft = scrollbarWrapper.scrollLeft;
        }
        // setIsScrolled(child1.scrollLeft > 0);
        // bgRef.current.style.backgroundColor="red"
        if (child1.scrollLeft > 0) {
          bgRef.current.forEach((row) => {
            if (row?.children?.[0]) {
              row.children[0].style.boxShadow = shadowStyle; // subtle right shadow
              // Ensure background is white
            }
          });
        } else {
          bgRef.current.forEach((row) => {
            if (row?.children?.[0]) {
              row.children[0].style.boxShadow = "none";
            }
          });
        }
      };

      const handleChild1Scroll = () => {
        if (scrollbarWrapper.scrollLeft !== child1.scrollLeft) {
          scrollbarWrapper.scrollLeft = child1.scrollLeft;
        }

        if (child1.scrollLeft > 0) {
          bgRef.current.forEach((row) => {
            if (row?.children?.[0]) {
              row.children[0].style.boxShadow = shadowStyle; // subtle right shadow
            }
          });
        } else {
          bgRef.current.forEach((row) => {
            if (row?.children?.[0]) {
              row.children[0].style.boxShadow = "none";
            }
          });
        }

        // bgRef.current.style.backgroundColor="red"
        // setIsScrolled(child1.scrollLeft > 0);
      };

      scrollbarWrapper.addEventListener("scroll", handleScroll);
      child1.addEventListener("scroll", handleChild1Scroll);
      // Cleanup event listeners on component unmount
      // return () => {
      //     scrollbarWrapper.removeEventListener('scroll', handleScroll);
      //     child1.removeEventListener('scroll', handleChild1Scroll);
      // };
    }
  }, [tableWidth, table.getRowModel().rows.length, activeCell, tableWidth, columnVisibility, view, body]);

  //to reset pageindex back to page 1, whenever we search something or columnfilter is applied

  useEffect(() => {
    //setResetPageIndex(true)
    table.setPageIndex(0);
  }, [columnFilters, globalFilter]);

  //looked like repetitive code, so commented out, but keeping it here for reference

  // useEffect(() => {
  //   localStorage.setItem("myTableColumnSizing", JSON.stringify(columnSizing));
  // }, [columnSizing]);

  // useEffect(() => {
  //   localStorage.setItem("myTableColumnSizing", JSON.stringify(columnSizing));
  // }, [columnSizing]);
  const columnSizeVars = React.useMemo(() => {
    const headers = table.getFlatHeaders();

    const colSizes = {};
    headers.forEach((header) => {
      colSizes[`--header-${header.id}-size`] = header.getSize();
      colSizes[`--col-${header.column.id}-size`] = header.column.getSize();
    });
    return colSizes;
  }, [table.getState().columnSizing]);

  const handleExpandAll = useCallback(() => {
    table.toggleAllRowsExpanded(!allExpanded);
    setAllExpanded((prev) => !prev);
  }, [allExpanded, table]);

  const selectedRowsObject = table.getSelectedRowModel().rows.reduce((acc, row) => {
    acc[row.original.id] = true;
    return acc;
  }, {});

  const getResizeHandler = useCallback(
    (header, table) => (e) => {
      e.stopPropagation();

      const column = table.getColumn(header.column.id);

      if (!column?.getCanResize()) return;

      table.setColumnSizing((prev) => ({
        ...prev,
        [column.id]: header.getSize(),
      }));

      const startX = e.clientX;
      const startSize = header.getSize();

      const onMouseMove = (e) => {
        const delta = e.clientX - startX;
        const newSize = Math.max(startSize + delta, 0);

        table.setColumnSizing((prev) => {
          const updated = { ...prev, [column.id]: Math.max(newSize, column.id === "customer_name" ? 150 : 62) };

          columnSizingRef.current = updated;
          return updated;
        });
      };

      const onMouseUp = () => {
        const payload = {
          field_management: {
            column_sizing: Object.keys(columnSizingRef.current).length > 0 ? columnSizingRef.current : null,
          },
        };

        if (isMetaApiCall) receiveMetaDataPayload(payload);

        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);

        // Optional: Reset resizing info
        table.setColumnSizingInfo((info) => ({
          ...info,
          isResizingColumn: null,
          startOffset: null,
          startSize: null,
        }));
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);

      table.setColumnSizingInfo((info) => ({
        ...info,
        isResizingColumn: column.id,
        startOffset: startX,
        startSize,
      }));
    },
    []
  );

  //all the terms related to the scrollable tabs and pinned headers

  useEffect(() => {
    const defaultHeaderMovedtoTop = table.getAllColumns().find((col) => col.id === "type");
    if (defaultHeaderMovedtoTop) {
      setHeadersMovedtoTop(defaultHeaderMovedtoTop);
    }
  }, [table.getAllColumns()]);

  const [headersMovedtoTop, setHeadersMovedtoTop] = useState(null);

  // console.log("headersMovedtoTop", headersMovedtoTop);
  // console.log("defaultheadersMovedtoTop", defaultHeaderMovedtoTop);

  const sortSelectedCheckBoxData = ({ tableBody = [] }) => {
    return tableBody?.filter((row) => Object.keys(multiData)?.includes(row?.id?.toString()));
  };

  return (
    <>
      <div className="flex h-full gap-1 ">
        <div className="h-full min-w-0 grow flex flex-col w-full  ">
          {hiddenTableTopOuterInputs && (
            <div
              className={`flex bg-white ${!narrowHeader && "my-2  mb-2 "} gap-x-2 justify-between droppingarea   w-[100%] ${tableDetail.tableName ? "" : ""}`}
            >
              <div
                className={
                  otherComponentView
                    ? "flex flex-col items-start gap-2 min-w-0 flex-grow"
                    : "flex items-center gap w-[50%] "
                }
              >
                {/* {leftPanel && !otherComponentView && (
                  <ToolTipComponent disableInteractive text={<>Advanced Filters</>} offset={"slightly-right"}>
                    <button
                      className="px-[5px] py-[3px] rounded-[5px] text-primary"                          
                          >
                      <SettingsIconLeftPanel
                        onClick={() => {
                          handleAdvancedFilterClickConfirmation();
                        }}
                      />
                    </button>
                  </ToolTipComponent>
                )} */}
                {dynamicScrollableTabs ? (
                  <div className="flex items-center justify-center max-w-[60vw] overflow-x-auto overflow-y-hidden">
                    <GetMappedTabs headersMovedtoTop={headersMovedtoTop} />
                  </div>
                ) : (
                  <>
                    {" "}
                    {tableDetail.tableFilter && (
                      <div className="flex items-center min-w-0 flex-grow bg-white rounded-[5px] ">
                        {tableDetail.tableFilter}
                      </div>
                    )}
                  </>
                )}
              </div>
              <div
                className={`flex justify-between ${otherComponentView ? "items-end" : "items-center"} gap-1 me-1 h-full`}
              >
                {otherComponentView && kanbanSearchIcon && (
                  <div className="w-[240px]">
                    <div className="flex items-center justify-center group">
                      <div className="relative flex left-8 items-center justify-end pb-[1px]">
                        <SearchIcon />
                      </div>
                      <input
                        type="text"
                        placeholder="Type name for search..."
                        value={columnSearchTerms || ""}
                        onChange={(e) => handleItemSearch(e)}
                        className="h-[28px] w-full pl-7  border-[1px] text-[#848687] border-[#E9E9E9] rounded-[5px] text-xs focus:outline-none focus:ring-0 focus:border-D9D9D9"
                      />
                      <div
                        className="relative right-7 flex items-center justify-end cursor-pointer w-2.5 h-2.5 invisible group-hover:visible "
                        onClick={handleSearchItemClear}
                      >
                        <CloseModalImg />
                      </div>
                    </div>
                  </div>
                )}

                {/* {!(isMySpace || isCustomModule) && (
                  <div
                    className={` group  cursor-pointer min-w-0 grow p-2  h-8 items-center justify-center flex group hover:bg-[#F0F0F0] rounded-md  ${otherComponentView ? "mb-3" : ""}`}
                  >
                    <button className="btn btn-success flex items-center gap-2 " onClick={handleImportClick}>
                      <ToolTipComponent darkMode disableInteractive text={<>Import</>} offset={"slightly-right"}>
                        <span className="text-primary"><ImportIcon className=" fill-[#8E8E8E] group-hover:fill-current" /></span>
                      </ToolTipComponent>                     
                    </button>
                    {isImportPopupOpen && (
                      <ImportPopupComponent open={isImportPopupOpen} onClose={() => setIsImportPopupOpen(false)} />
                    )}
                  </div>
                )} */}

                {!otherComponentView && (
                  <div className="flex items-center gap-1 ">
                    <div className="flex items-center relative">
                      {
                        <div className="relative w-full">
                          {
                            <DebouncedInput
                              value={globalFilter ?? ""}
                              onChange={(value) => setGlobalFilter(String(value))}
                              className={`h-[1.8rem] ${isSearchActive ? "w-[164px] rounded-full focus:border-primary " : "w-0 border-none"} pr-10 pl-3 font-lg font-Inter text-12 font-400 transform duration-300   hover:bg-[#fff]`}
                              placeholder="Search..."
                            />
                          }

                          {/* Clickable Search icon inside input */}
                          <div
                            className="absolute right-0 top-3.5 transform -translate-y-1/2 ml-3 text-gray-500 cursor-pointer"
                            // onClick={toggleSearchIcon}
                          >
                            <ToolTipComponent darkMode text="Search">
                              <span
                                onClick={toggleSearchIcon}
                                className="cursor-pointer  border-[#EBF2F6] rounded-full hover:bg-[#F6F6F6] hover:border-transparent"
                              >
                                <SearchIcon isHovered={isHovered} isActive={isSearchActive} />
                              </span>
                            </ToolTipComponent>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                )}

                {excelDownload && checkAccessPermission("Download") && (
                  <div className=" group  cursor-pointer min-w-0 grow p-2 hover:bg-[#F0F0F0] h-8 items-center justify-center flex rounded-md">
                    <button
                      className="btn btn-success flex items-center gap-2"
                      onClick={() => {
                        if (Object.keys(multiData)?.length > 0) {
                          exportExcel(
                            sortSelectedCheckBoxData({ tableBody: table.getFilteredRowModel().rows }),
                            rawHeaders,
                            setExcelDownloadLoading
                          );
                        } else {
                          exportExcel(table.getFilteredRowModel().rows, rawHeaders, setExcelDownloadLoading);
                        }
                      }}
                    >
                      <ToolTipComponent
                        darkMode
                        disableInteractive
                        text={excelDownloadLoading ? <>Excel Preparing to Download...</> : <>Download</>}
                        offset={"slightly-right"}
                      >
                        {excelDownloadLoading ? (
                          <CircularProgress size={20} sx={{ color: "var(--color-primary)" }} thickness={1.5} />
                        ) : (
                          <ExcelICon className=" fill-[#8E8E8E] group-hover:fill-[#004EFF]" />
                        )}
                      </ToolTipComponent>
                      {/* <span className="text-[#848687] group-hover:text-white text-sm font-normal">Download</span> */}
                    </button>
                  </div>
                )}

                {grouping?.length > 0 && (
                  <ToolTipComponent disableInteractive darkMode text={<>Clear Grouping</>} offset={"slightly-right"}>
                    <div
                      className={`p-1 items-center group cursor-pointer hover:bg-[#F0F0F0]  justify-center flex rounded-md `}
                      onClick={() => {
                        handleClearAllGrouping();
                      }}
                    >
                      <ClearGrouping className=" ml-[2px] mb-[1px] fill-[#8E8E8E] group-hover:fill-primary" />
                    </div>
                  </ToolTipComponent>
                )}
                {grouping?.length > 0 && (
                  <div
                    className={`min-w-0 grow p-1 items-center justify-center group rounded-md flex hover:bg-[#CECECE4D]`}
                  >
                    <ToolTipComponent
                      darkMode
                      disableInteractive
                      text={allExpanded ? "Collapse All" : "Expand All"}
                      offset={"slightly-right"}
                    >
                      <button className="btn btn-success flex items-center gap-2" onClick={handleExpandAll}>
                        <span className=" text-sm font-normal">
                          {allExpanded ? (
                            <CollapseAll className="group-hover:fill-primary fill-[#8E8E8E]" />
                          ) : (
                            <ExpendAll className="group-hover:fill-primary fill-[#8E8E8E]" />
                          )}
                        </span>
                      </button>
                    </ToolTipComponent>
                  </div>
                )}
                {ExtraFields && ExtraFields}
                <div className="w-[1.5px] h-9 bg-[#C3CED8] mr-2"></div>

                {!otherComponentView && !hiddenAction && (
                  <div
                    className={`flex items-center gap-1 border ${leftPanel ? "rounded-full" : "rounded-2xl"} px-1.5  `}
                  >
                    <ToolTipComponent darkMode text="Filter">
                      <span
                        onClick={toggleFilterActive}
                        className={`cursor-pointer flex items-center justify-center rounded-full ${leftPanel ? "h-[30px]" : "h-[26px]"}`}
                      >
                        <FilterIcon isHovered={isFilterHovered} isActive={isFilterActive} />
                      </span>
                    </ToolTipComponent>
                    {leftPanel && (
                      <ToolTipComponent
                        disableInteractive
                        darkMode
                        text={<>Advanced Filters</>}
                        offset={"slightly-right"}
                      >
                        <button className="flex items-center justify-center  h-[30px] rounded-full">
                          <SettingsIconLeftPanel
                            isActive={isAdvancedFilterOpen}
                            onClick={() => {
                              handleAdvancedFilterClickConfirmation();
                            }}
                          />
                        </button>
                      </ToolTipComponent>
                    )}
                  </div>
                )}
                {MainFields && MainFields}
              </div>
            </div>
          )}
          <div className="w-full">{TableDashboard && TableDashboard}</div>
          {otherComponentView ? (
            otherComponent
          ) : (isMySpace || isCustomModule ? table.getRowModel().rows.length > 0 : true) &&
            !(apiStates?.header?.isError || apiStates?.body?.isError) ? (
            <div className="overflow-x-auto grow min-h-0 w-full flex flex-col bg-[#F8F8F8] mt-2" id="fakeHeaderId">
              <div
                ref={child1Ref}
                className={` bg-white overflow-y-auto flex-grow customscrollbar rounded-t-md  ${
                  !activeCell || (activeCell.rowId == null && activeCell.colId == null)
                    ? "hide-scrollbar-x"
                    : "overflow-x-hidden"
                }`}
                //  style={{ height: "100%" }}
              >
                <table
                  ref={tableRef}
                  className="fullscreen-table  border-collapse    text-[13px] text-center font-poppins table-fixed text-2C495D overflow-auto"
                  style={{
                    ...(table.getHeaderGroups()[0]?.headers?.length > 2 ? { minWidth: "100%" } : { width: "100%" }),
                    ...columnSizeVars,
                    width: tableWidth,
                    height: table.getRowModel().rows.length == 0 ? "100%" : "",
                  }}
                >
                  <thead className=" capitalize sticky">
                    {table.getHeaderGroups().map((headerGroup, index) => (
                      <tr key={headerGroup.id} ref={(el) => (bgRef.current[1000] = el)}>
                        {headerGroup.headers.map((header, index) => {
                          const { column } = header;
                          const sortState = column.getIsSorted();

                          const isGroupedColumn = column.id === "groupedColumn";
                          const isAlreadyGrouped = grouping?.includes(column.id);

                          const isDropdown = header?.column?.columnDef?.meta?.type === "dropdown";

                          return (
                            <th
                              key={header.id}
                              colSpan={header.colSpan}
                              className={` relative text-left  whitespace-nowrap  text-ellipsis border-x-0 bg-secondary z-[1]  cursor-pointer ${index == 0 && isScrolled && "shadow-[-4px_0_4px_-4px_gray_inset]"}  group`}
                              style={{
                                width: `calc(var(--header-${header.id}-size) * 1px)`,
                                ...getCommonPinningStyles(column, table, noMenuOpenList, defaultPinnedColumn),
                              }}
                              draggable={
                                !isGroupedColumn && !headerGroup.headers?.some((h) => h.column.getIsResizing())
                              }
                              onDragStart={() => handleDragStart(header.column)}
                              onDragOver={(e) => e.preventDefault()}
                              onDrop={(e) => (isGroupedColumn ? handleDrop(e) : handleReorder(e, header.column))}
                            >
                              <div className="">
                                {header.isPlaceholder ? null : (
                                  <>
                                    <div
                                      className={`w-full   min-h-9  flex justify-between items-center gap-3  relative text-[#616161] font-[400] text-[12px] leading-none font-poppins`}
                                    >
                                      <div className="min-w-0 grow   pl-3  flex items-center gap-x-2 min-h-full">
                                        <div className="grow min-w-0 truncate leading-relaxed text-primary-text font-medium">
                                          {flexRender(header.column.columnDef.header, header.getContext())}
                                          {sortState && <span className="text-black">*</span>}
                                        </div>
                                        {sortState === "asc" && (
                                          <span className="p-2 rounded-md bg-gray-200 w-fit hover:bg-primary-active">
                                            <SortAscIcon
                                              size={14}
                                              color="#666"
                                              onClick={() => {
                                                handleSort(header, "desc");
                                              }}
                                            />
                                          </span>
                                        )}{" "}
                                        {sortState === "desc" && (
                                          <span className="p-2 rounded-md bg-gray-200 hover:bg-primary-active">
                                            <SortDescIcon
                                              size={14}
                                              color="#666"
                                              onClick={() => {
                                                handleSort(header, "asc");
                                              }}
                                            />
                                          </span>
                                        )}
                                      </div>

                                      <div
                                        className={`flex h-9 text-primary-text ${header.column.getIsResizing() && "shadow-[-5px_0_5px_-5px_rgba(0,0,0,0.5)]"} `}
                                      >
                                        {!noMenuOpenList?.includes(header.id) && (
                                          <>
                                            <button
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                toggleDropdown(header.id);
                                              }}
                                              className="min-w-fit p-2.5"
                                            >
                                              <ThreeDotsVertical className="fill-current" />
                                            </button>
                                            <div
                                              onMouseDown={getResizeHandler(header, table)}
                                              className={`pl-1  w-fit h-full cursor-ew-resize   border-r-[2px] border-transparent    transition-opacity duration-200 group-hover:!border-r-primary   ${header.column.getIsResizing() ? "!border-r-primary" : ""} `}
                                            ></div>
                                          </>
                                        )}
                                      </div>
                                      {openDropdownId === header.id && (
                                        <div
                                          ref={dropdownRef}
                                          className={`absolute  ${
                                            header === table.getHeaderGroups()[0].headers.at(-1)
                                              ? "right-1"
                                              : "right-[-55px]"
                                          } top-8 ${
                                            isFilterActive ? "mt-[3.7rem]" : "mt-2"
                                          } w-44 bg-white border border-gray-300 shadow-lg rounded`}
                                        >
                                          <ul>
                                            {dynamicScrollableTabs && isDropdown && (
                                              <li
                                                className="p-2 hover:bg-gray-100 cursor-pointer text-[#778FA5] flex items-center gap-1 text-[12px]"
                                                onClick={() => {
                                                  console.log("header.column", header.column);

                                                  table.resetColumnFilters();
                                                  setOpenDropdownId(null);
                                                  setHeadersMovedtoTop(header.column);
                                                }}
                                              >
                                                <SortIncreasing className="w-4 h-4 shrink-0" />
                                                <span className="block max-w-15 truncate">
                                                  Move to Scrollable Tabs{" "}
                                                </span>
                                              </li>
                                            )}
                                            {!["groupedColumn", "delegation"].includes(header.id) && (
                                              <>
                                                {sortState !== "asc" && (
                                                  <li
                                                    className="p-2 hover:bg-primary-hover cursor-pointer text-primary-text  hover:text-primary flex items-center gap-1 text-sm"
                                                    onClick={() => {
                                                      handleSort(header, "asc");
                                                      setOpenDropdownId(null);
                                                    }}
                                                  >
                                                    <SortIncreasing className="w-4 h-4 shrink-0 fill-current" />
                                                    Sort by Increasing
                                                  </li>
                                                )}
                                                {sortState !== "desc" && (
                                                  <li
                                                    className="p-2 hover:bg-primary-hover cursor-pointer text-primary-text  hover:text-primary flex items-center gap-1 text-sm"
                                                    onClick={() => {
                                                      handleSort(header, "desc");
                                                      setOpenDropdownId(null);
                                                    }}
                                                  >
                                                    <SortDecreasing className="w-4 h-4 shrink-0 fill-current" />
                                                    Sort by Decreasing
                                                  </li>
                                                )}
                                                {(sortState == "asc" || sortState == "desc") && (
                                                  <li
                                                    className="p-2 hover:bg-primary-hover cursor-pointer text-primary-text  hover:text-primary flex items-center gap-1 text-sm"
                                                    onClick={() => {
                                                      column.clearSorting();
                                                      setOpenDropdownId(null);
                                                    }}
                                                  >
                                                    <span className="text-primary">
                                                      <CrossIcon className="w-[0.7rem] h-[0.7rem] fill-primary-text" />
                                                    </span>
                                                    Unsort
                                                  </li>
                                                )}
                                              </>
                                            )}
                                            {grouping?.length > 0 && header.id === "groupedColumn" && (
                                              <>
                                                {grouping.map((item) => (
                                                  <li
                                                    key={item}
                                                    className="p-2 hover:bg-primary-hover cursor-pointer text-primary-text text-sm hover:text-primary group"
                                                    onClick={() => removeGrouping(item)}
                                                  >
                                                    <span className="block flex items-center gap-1 text-primary-text group-hover:text-primary">
                                                      {" "}
                                                      <StopGroup className="fill-current" /> {"Stop Grouping By"}
                                                    </span>
                                                    <span className="block max-w-15 truncate">
                                                      {" "}
                                                      {table
                                                        .getAllColumns()
                                                        .filter((col) => col.columnDef.accessorKey === item)
                                                        .map((col) => col.columnDef.header)[0] || item}
                                                    </span>
                                                  </li>
                                                ))}
                                                {grouping?.length > 1 && (
                                                  <li
                                                    className="p-2 hover:bg-gray-100 cursor-pointer text-[#778FA5] text-[12px]"
                                                    onClick={() => {
                                                      setOpenDropdownId(null);
                                                      setGrouping([]);
                                                      // setColumnVisibility((prevVisibility) => ({
                                                      //   ...prevVisibility,
                                                      //   groupedColumn: false,
                                                      // }));
                                                    }} // Clear all groupings
                                                  >
                                                    Clear Grouping
                                                  </li>
                                                )}
                                              </>
                                            )}
                                            {!(isMySpace || isCustomModule) && header.id !== "groupedColumn" && (
                                              <li
                                                className="p-2 hover:bg-primary-hover cursor-pointer hover:text-primary text-primary-text text-sm  flex items-center gap-1"
                                                onClick={() => {
                                                  header.column.getToggleGroupingHandler()();
                                                  setOpenDropdownId(null);
                                                }}
                                              >
                                                {header.column.getIsGrouped() ? (
                                                  <StopGroup className="w-4 min-w-fit mt-[2px] fill-current" />
                                                ) : (
                                                  <GroupingBy className="w-3 min-w-fit mt-[2px] fill-current" />
                                                )}
                                                <span className="block ">
                                                  {" "}
                                                  {/* Ensure Group By/Stop Grouping By is on its own line */}
                                                  {header.column.getIsGrouped() ? "Stop Grouping By" : "Group By"}
                                                </span>
                                                <span className="block max-w-15 truncate ">
                                                  {" "}
                                                  {/* Ensure column name is on the next line */}
                                                  {flexRender(header.column.columnDef.header, header.getContext())}
                                                </span>
                                              </li>
                                            )}
                                            <li
                                              className="p-2 hover:bg-primary-hover cursor-pointer hover:text-primary flex items-center gap-1 text-primary-text"
                                              onClick={(e) => {
                                                // header.column.pin('left')
                                                handlePin(table, header);
                                                setOpenDropdownId(null);
                                              }}
                                            >
                                              <PinIcon className=" w-4 h-4 fill-current" />
                                              {header.column.getIsPinned() == "left" ? "Unpin" : "Pin to Left"}
                                            </li>
                                            {showColumnEdit && (
                                              <li
                                                className="p-2 hover:bg-primary-hover cursor-pointer hover:text-primary text-primary-text flex items-center gap-1"
                                                onClick={(e) => {
                                                  editColumnCallBack(header.column);
                                                }}
                                              >
                                                <EditIcon className=" w-4 h-4 fill-current" />
                                                Edit
                                              </li>
                                            )}
                                            {showColumnDelete && (
                                              <li
                                                className="p-2 hover:bg-primary-hover cursor-pointer hover:text-primary text-primary-text flex items-center gap-1"
                                                onClick={(e) => {
                                                  deleteColumnCallBack(header.column);
                                                }}
                                              >
                                                <DeleteIcon className=" w-4 h-4 fill-current" />
                                                Drop Column
                                              </li>
                                            )}
                                          </ul>
                                        </div>
                                      )}

                                      {/* Sorting Indicators */}
                                      {/* {{
                                    asc: " 🔼",
                                    desc: " 🔽",
                                  }[header.column.getIsSorted() || ""] || null} */}
                                    </div>
                                    {/*Filter Input Box */}
                                    {header.column.getCanFilter() && isFilterActive ? (
                                      <div className="mt-2">
                                        <MemoizedFilter
                                          column={header.column}
                                          isMySpace={isMySpace}
                                          isCustomModule={isCustomModule}
                                          visibleRows={table.getRowModel().rows}
                                          generateUniqueValues={generateUniqueValues}
                                          useGenerateUniqueValues={useGenerateUniqueValues}
                                          useBuildOptionsFromList={useBuildOptionsFromList}
                                          buildOptionsFromList={buildOptionsFromList}
                                        />
                                      </div>
                                    ) : isFilterActive ? (
                                      <div className="min-h-9 mt-2"></div>
                                    ) : null}
                                  </>
                                )}
                              </div>
                              {/* {!header.isPlaceholder && header.column.getCanPin() && (
                        <div className="flex gap-1 justify-center">
                          {header.column.getIsPinned() !== 'left' ? (
                            <button
                              className="border rounded px-2"
                              onClick={() => {
                                header.column.pin('left')
                              }}
                            >
                              {'<'}
                            </button>
                          ) : null}
                          {header.column.getIsPinned() ? (
                            <button
                              className="border rounded px-2"
                              onClick={() => {
                                header.column.pin(false)
                              }}
                            >
                              X
                            </button>
                          ) : null}
                          {header.column.getIsPinned() !== 'right' ? (
                            <button
                              className="border rounded px-2"
                              onClick={() => {
                                header.column.pin('right')
                              }}
                            >
                              {'=>'}
                            </button>
                          ) : null}
                        </div>
                      )} */}
                            </th>
                          );
                        })}
                      </tr>
                    ))}
                  </thead>
                  {table.getRowModel().rows.length > 0 ? (
                    <>
                      {table.getState().columnSizingInfo.isResizingColumn ? (
                        <MemoizedTableBody
                          table={table}
                          grouping={grouping}
                          rawHeaders={rawHeaders}
                          activeCell={activeCell}
                          setActiveCell={setActiveCell}
                          handleOtherDetailChange={handleOtherDetailChange}
                          fetchPersonInTable={fetchPersonInTable}
                          customerCommnData={customerCommnData}
                          clientCoord={clientCoord}
                          refetchCustomerData={refetchCustomerData}
                          updateTableField={updateTableField}
                          multiData={multiData}
                          expanded={expanded}
                          subtaskExpanded={subtaskExpanded}
                          isScrolled={isScrolled}
                          noMenuOpenList={noMenuOpenList}
                          handleRowEditClick={handleRowEditClick}
                          handleRowClick={handleRowClick}
                          selectedRowId={selectedRowId}
                          rowClickDisabled={rowClickDisabled}
                          bgRef={bgRef}
                          defaultPinnedColumn={defaultPinnedColumn}
                          isViewSwitchable={isViewSwitchable}
                          compactViewSwitchButton={compactViewSwitchButton}
                          SubTaskClick={SubTaskClick}
                          isSubtasKThere={isSubtasKThere}
                        />
                      ) : (
                        <TableBody
                          table={table}
                          grouping={grouping}
                          rawHeaders={rawHeaders}
                          activeCell={activeCell}
                          setActiveCell={setActiveCell}
                          handleOtherDetailChange={handleOtherDetailChange}
                          fetchPersonInTable={fetchPersonInTable}
                          customerCommnData={customerCommnData}
                          clientCoord={clientCoord}
                          refetchCustomerData={refetchCustomerData}
                          updateTableField={updateTableField}
                          multiData={multiData}
                          expanded={expanded}
                          subtaskExpanded={subtaskExpanded}
                          isScrolled={isScrolled}
                          noMenuOpenList={noMenuOpenList}
                          handleRowEditClick={handleRowEditClick}
                          isMySpace={isMySpace}
                          isCustomModule={isCustomModule}
                          handleRowClick={handleRowClick}
                          selectedRowId={selectedRowId}
                          rowClickDisabled={rowClickDisabled}
                          bgRef={bgRef}
                          defaultPinnedColumn={defaultPinnedColumn}
                          isViewSwitchable={isViewSwitchable}
                          compactViewSwitchButton={compactViewSwitchButton}
                          SubTaskClick={SubTaskClick}
                          isSubtasKThere={isSubtasKThere}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      <tr>
                        <td colSpan={table.getHeaderGroups()?.[0]?.headers?.length} className="relative">
                          <div className=" text-center  h-full py-4 w-max  sticky left-1/2 transform -translate-x-1/2">
                            <AlternateView
                              apiStates={apiStates}
                              alternateDivs={alternateDivs}
                              searchTerm={globalFilter}
                              columnFilters={columnFilters}
                              data={body}
                              table={table}
                            />
                          </div>
                        </td>
                      </tr>
                    </>
                  )}
                </table>
              </div>
              {true && (
                <div className="flex items-center justify-between bg-white gap-2 px-4 py-1.5 border-t-2 border-[#D2DAE1] ">
                  <div ref={paginationRef} className="flex min-w-fit auto flex-grow gap-3 w-1/2">
                    {/* Page Size Selector */}
                    <div className="relative w-fit" ref={dropdownRef}>
                      <BasicSelect
                        options={pageSizes || []}
                        name="pageSize"
                        selectedOptions={pageSizes?.filter(
                          (option) => option?.value === table.getState().pagination.pageSize
                        )}
                        onChange={(e) => table.setPageSize(Number(e.target.value))}
                        onClick={() => {
                          table.setPageSize(pageSizes[0]?.value);
                        }}
                        type={"select"}
                        size={"medium"}
                      />
                    </div>

                    {/* Pagination Controls */}
                    <div className="bg-white min-w-fit ">
                      <ul className="globalpagination  border rounded border-[#DDE1E3] text-sm font-medium text-[#535252]  py-[0.16875rem]  items-center justify-center flex gap-1">
                        {/* First Page */}
                        <li>
                          <button
                            className="hover:border-primary-40 px-1 py-0.5 rounded text-[#535252] "
                            onClick={() => {
                              table.setPageIndex(0);
                            }}
                            disabled={!table.getCanPreviousPage()}
                          >
                            <i className="bi bi-chevron-double-left   text-sm font-medium text-[#535252]"></i>
                          </button>
                        </li>

                        {/* Previous Page */}
                        <li>
                          <button
                            className="hover:border-primary-40 px-1 py-0.5 rounded "
                            onClick={() => {
                              table.previousPage();
                              setResetPageIndex(false);
                            }}
                            disabled={!table.getCanPreviousPage()}
                          >
                            <i className="bi bi-chevron-left  font-medium"></i>
                          </button>
                        </li>

                        {/* Page Numbers */}
                        {pageNumbers.map((page, index) => (
                          <li
                            key={index}
                            className={`${
                              table.getState().pagination.pageIndex === page - 1
                                ? " border-primary border  hover:border-primary-40  rounded items-center " // Apply red border for active page
                                : "" // Default border color for inactive pages
                            } rounded  flex items-center justify-center `} // Set padding for square shape
                          >
                            {page === "..." ? (
                              <span className=" rounded ">...</span>
                            ) : (
                              <button
                                className={`  text-sm font-medium  ${
                                  table.getState().pagination.pageIndex === page - 1
                                    ? " border-383838 px-2"
                                    : "hover:border-primary-40  rounded items-center  py-0.5 px-2" // Ensure the button is square
                                }`}
                                style={{ color: "#535252" }}
                                onClick={() => {
                                  table.setPageIndex(page - 1);
                                  setResetPageIndex(false);
                                  setMultiData({});
                                }}
                              >
                                {page}
                              </button>
                            )}
                          </li>
                        ))}

                        {/* Next Page */}
                        <li>
                          <button
                            className="rounded hover:border-primary-40 px-1 py-0.5 "
                            onClick={() => {
                              table.nextPage();
                              setResetPageIndex(false);
                            }}
                            disabled={!table.getCanNextPage()}
                          >
                            <i className="bi bi-chevron-right  font-medium"></i>
                          </button>
                        </li>

                        {/* Last Page */}
                        <li>
                          <button
                            className="rounded hover:border-primary-40 px-1 py-0.5"
                            onClick={() => {
                              table.setPageIndex(table.getPageCount() - 1);
                              setResetPageIndex(false);
                            }}
                            disabled={!table.getCanNextPage()}
                          >
                            <i className="bi bi-chevron-double-right  font-medium"></i>
                          </button>
                        </li>
                      </ul>
                    </div>

                    {/* Total Records */}
                    <div className="flex items-center">
                      <p className=" bg-none  bg-white font-medium text-sm  text-535252 min-w-fit flex items-center gap-1">
                        <span>Count </span>
                        <span className="mt-[-1px]"> :: </span>
                        <span> {table.getFilteredRowModel().rows.length}</span>
                      </p>
                    </div>
                  </div>
                  {true && (
                    <div
                      className={`flex w-1/2 ${!activeCell || (activeCell.rowId == null && activeCell.colId == null) ? "" : "hidden"}`}
                    >
                      <div className={`px-2 ${scrollbarWidth === "0px" ? "hidden" : ""}`}>
                        <ThreeDotsVertical />
                      </div>
                      <div className="flex justify-between items-center w-1/2 ml-1/4 min-w-0 grow">
                        <button
                          className={`z-50 mr-[-20px] bg-[#5d5f60] bg-opacity-100 text-white px-2 h-[15px] text-sm rounded-l-full flex items-center justify-center ${
                            scrollbarWidth === "0px" ? "hidden" : ""
                          }`}
                          onClick={() => handleScroll("previous")}
                        >
                          <span className="" style={{ fontSize: "7.5px" }}>
                            &#9664;
                          </span>
                        </button>
                        <div
                          className={`flex-grow overflow-x-auto overflow-y-hidden scrollbar-thin customscrollbar1 h-[15px] w-[calc(${scrollbarWidth})] `}
                          style={{}}
                          ref={scrollbarWrapperRef}
                        >
                          <div
                            style={{
                              width: `calc(${scrollbarWidth} - ${paginationRef?.current?.clientWidth}px)`,
                              height: "1px",
                            }}
                          ></div>
                        </div>
                        <button
                          className={`z-50 ml-[-20px]  bg-[#5d5f60] bg-opacity-100 text-white px-2 h-[15px] text-sm rounded-r-full flex items-center justify-center ${
                            scrollbarWidth === "0px" ? "hidden" : ""
                          }`}
                          onClick={() => handleScroll("next")}
                        >
                          <span className="" style={{ fontSize: "7.5px" }}>
                            &#9654;
                          </span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : (
            <>
              <AlternateView
                apiStates={apiStates}
                alternateDivs={alternateDivs}
                searchTerm={globalFilter}
                data={body}
                table={table}
                isMySpace={isMySpace}
                isCustomModule={isCustomModule}
                isMySpaceCreateColumnHtml={isMySpaceCreateColumnHtml}
              />
            </>
          )}
        </div>
        {isAdvancedFilterOpen && (
          <div className="mt-2 px-2 py-[10px] w-80 h-full rounded-md border border-[#D2DAE1] bg-white shadow-[0px_2.667px_2.667px_0px_rgba(0,0,0,0.05)]">
            <AdvancedFilterComponent
              groupBy={grouping}
              setGroupBy={setGrouping}
              handleClearAllGrouping={handleClearAllGrouping}
              table={table}
              view={view}
              metaData={metaData?.filter_management}
              refetchHeader={refetchHeader}
              closeAdvancedFilter={handleAdvancedFilterClickConfirmation}
              disableSaveFilter={disableSaveFilter}
              receiveMetaDataPayload={receiveMetaDataPayload}
            />
          </div>
        )}
      </div>
      {showConfirmationAdvancedFilter && (
        <ConfirmationDialog
          open={showConfirmationAdvancedFilter}
          onConfirm={(e) => handleAdvancedFilterClick()}
          onClose={() => setShowConfirmationAdvancedFilter(false)}
          title="Switch to Advanced Filter?"
          message="This will remove all the current filters applied"
          confirmVariant="primary"
          iconVariant="primary"
          confirmText="Yes"
          cancelText="No"
        />
      )}
      {showConfirmationFilter && (
        <ConfirmationDialog
          open={showConfirmationFilter}
          onConfirm={(e) => handleFilterClick()}
          onClose={() => setShowConfirmationFilter(false)}
          title="Switch to  Filter?"
          message="This will remove all the current advanced filters applied"
          confirmVariant="primary"
          iconVariant="primary"
          confirmText="Yes"
        />
      )}
    </>
  );
};

const TableBody = ({
  table,
  grouping,
  rawHeaders,
  activeCell,
  setActiveCell,
  handleOtherDetailChange,
  fetchPersonInTable,
  customerCommnData,
  clientCoord,
  refetchCustomerData,
  updateTableField,
  multiData,
  expanded,
  subtaskExpanded,
  isScrolled,
  selectedRowId,
  noMenuOpenList,
  handleRowEditClick,
  isMySpace,
  isCustomModule,
  handleRowClick,
  rowClickDisabled,
  disableSaveFilter = false,
  bgRef,
  defaultPinnedColumn,
  isViewSwitchable,
  compactViewSwitchButton,
  SubTaskClick,
  isSubtasKThere,
}) => (
  <tbody>
    {table.getRowModel().rows.map((row, rowIndex) => {
      return (
        <>
          <tr
            key={row.id}
            className={`group border tablerow border-E1E6EC border-l-0 border-r-0
                      ${selectedRowId?.includes(row.id) ? "bg-primary-active" : "hover:bg-primary-hover bg-white"} 
                      `}
            ref={(el) => (bgRef.current[rowIndex] = el)}
            onClick={!rowClickDisabled ? () => handleRowClick(row.id) : undefined}
          >
            {row.getVisibleCells().map((cell, index) => {
              const { column } = cell;
              const isGroupedColumn = grouping?.includes(cell.column.id);
              const Header = rawHeaders?.filter((item) => item.value === cell.column.id)[0];

              const showCursorPointer = ![
                "select",
                "task_date",
                "notes",
                "customer_display_name",
                "country_id",
                "customer_name",
                "email",
                "phone",
                "type",
                "website",
                "nature",
                "customer_group",
                "deal",
                "lead",
              ].includes(cell.column.id);

              return (
                <td
                  key={cell.id}
                  className={`group-hover:bg-primary-hover ${selectedRowId?.includes(row.id) ? "bg-[#F0F0F0]" : "bg-white"} whitespace-nowrap border-b border-neutral-200 text-2C495D font-normal text-left text-[12px]  ${showCursorPointer && "cursor-pointer"} 
                              ${cell.column.getIsResizing() ? "border-r !border-r-gray-500 " : "!border-r-transparent"}`}
                  style={{
                    background: cell.getIsGrouped()
                      ? ""
                      : cell.getIsAggregated()
                        ? ""
                        : cell.getIsPlaceholder()
                          ? ""
                          : "",
                    marginLeft: cell.getIsGrouped()
                      ? ""
                      : cell.getIsAggregated()
                        ? ""
                        : cell.getIsPlaceholder()
                          ? "-30px"
                          : "",
                    width: `calc(var(--col-${cell.column.id}-size) * 1px)`,
                    ...getCommonPinningStyles(column, table, noMenuOpenList, defaultPinnedColumn),
                  }}
                  //  onClick={()=>toggleRender()}
                  // onClick={
                  //   !cell.getIsGrouped() &&
                  //   !["subject", "activity", "customer_name"].includes(cell.column.id)
                  //     ? (e) => {
                  //         e.stopPropagation();
                  //         handleNavigate(null, row.original);
                  //       }
                  //     : undefined
                  // }
                  //inside this we want to pass, row,column Id
                  onClick={(event) => {
                    if (handleRowEditClick) {
                      handleRowEditClick(event, row.original);
                    }
                    //handleRenderElementRowKey(row.id, cell.id);
                    else if (
                      ![
                        "select",
                        "tasks",
                        "notes",
                        "customer_display_name",
                        "country_id",
                        "customer_name",
                        "email",
                        "phone",
                        "type",
                        "website",
                        "nature",
                        "customer_group",
                        "deal",
                        "lead",
                      ].includes(cell.column.id) &&
                      !(isMySpace || isCustomModule)
                    ) {
                      handleOtherDetailChange(row.id, row, cell, event);
                    } else if ((isMySpace || isCustomModule) && !noMenuOpenList?.includes(cell.column.id)) {
                      handleOtherDetailChange(row.id, row, cell, event);
                    }
                  }}
                >
                  <div
                    className={`${(isMySpace || isCustomModule) && !noMenuOpenList?.includes(cell.column.id) && (!activeCell || activeCell?.rowId === null) ? "border border-transparent  hover:!border-gray-300" : ""} min-h-9 flex items-center w-full `}
                  >
                    {cell.column.id === "groupedColumn" ? (
                      // If it's a grouped cell, add an expander and row count
                      <>
                        {grouping.map((group, index) => {
                          const groupCell = row.getAllCells().find((c) => c.column.id === group);
                          return groupCell && index === row.depth ? (
                            <div key={groupCell.id} className="min-h-8 flex items-center">
                              {/* <button
                                {...{
                                  onClick: row.getToggleExpandedHandler(),
                                  style: {
                                    cursor: row.getCanExpand() ? "pointer" : "normal",
                                  },
                                }}
                              > */}
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  row.getToggleExpandedHandler()(e);
                                }}
                                style={{ cursor: row.getCanExpand() ? "pointer" : "normal" }}
                              >
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                  {row.depth > 0 && "\u00A0\u00A0\u00A0\u00A0".repeat(row.depth)}

                                  <span className="px-1">{row.getIsExpanded() ? "▼" : "▶"}</span>
                                  <span>
                                    {["customer_display_name"].includes(cell.column.id)
                                      ? cell.getValue()
                                      : flexRender(groupCell.column.columnDef.cell, {
                                          ...groupCell.getContext(),
                                          getValue: () =>
                                            groupCell.getContext().getValue() || (
                                              <span className="text-gray-300">NA</span>
                                            ),
                                        })}
                                  </span>
                                  <span>({row?.subRows?.length})</span>

                                  {/* {row.getIsExpanded() ? '👇' : '👉'}{' '}
                                {flexRender(
                                  groupCell.column.columnDef.cell,
                                  groupCell.getContext()
                                )}
                                ({row.subRows.length}) */}
                                </div>
                              </button>
                            </div>
                          ) : null;
                        })}
                      </>
                    ) : isGroupedColumn ? null : cell.getIsAggregated() ? (
                      // If the cell is aggregated, use the Aggregated
                      // renderer for cell
                      <></>
                    ) : cell.getIsPlaceholder() ? null : activeCell?.rowId == row.id &&
                      activeCell?.columnId == cell.id ? (
                      <div className="clickopennow flex items-center justify-between relative w-full">
                        <div className="relative w-full h-full">
                          <RenderElementsCopy
                            tableDetail={{ tableidclass: "fullscreen-table z-customer-45" }}
                            fetchPersonInTable={fetchPersonInTable}
                            Item={row.original}
                            RowKey={row.original.id}
                            Header={Header}
                            rawHeaders={rawHeaders}
                            CommonData={customerCommnData}
                            DataRow={activeCell}
                            setDataRow={setActiveCell}
                            clientCoord={clientCoord}
                            refetchCustomerData={refetchCustomerData}
                            UpdateField={updateTableField}
                            cell={cell}
                            multiData={multiData}
                            isMySpace={isMySpace}
                            isCustomModule={isCustomModule}
                            meta={cell.column.columnDef.meta}
                          />
                        </div>
                      </div>
                    ) : (
                      // <div className={`${cell.column.id !== "tasks" && "mx-4"}   text-black min-h-6  `}>
                      <div className={` flex items-center   text-black min-h-7 w-full  px-3`}>
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </div>
                    )}
                  </div>
                </td>
              );
            })}
          </tr>
          {expanded[row.id] && // Check if the row has sub-rows and is expanded
            row.subRows.map((subRow) => (
              <tr key={subRow?.id} className="border-t border-gray-300 bg-gray-100">
                {subRow.getVisibleCells().map((subCell) => (
                  <td key={subCell.id} className="border border-gray-300 p-2 whitespace-nowrap pl-8">
                    {subCell.column.columnDef.cell({
                      getValue: subCell.getValue,
                      row: subCell.row,
                    })}
                  </td>
                ))}
              </tr>
            ))}
          {isSubtasKThere &&
            subtaskExpanded[row.id] &&
            row.original.sub_tasks.map((subtask, subtaskIndex) => {
              return (
                <tr
                  key={`subtask-${row.id}-${subtaskIndex}`}
                  className="cursor-pointer hover:bg-primary-hover bg-white group tablerow"
                >
                  {row.getVisibleCells().map((cell) => {
                    // Create a context for the subtask using the existing cell context
                    const subtaskContext = {
                      ...cell.getContext(),
                      row: {
                        ...cell.getContext().row,
                        original: subtask, // Replace original data with subtask data
                      },
                    };
                    const isSubjectColumn = cell.column.id === "subject";
                    const marginClass = isSubjectColumn ? "ms-12" : "ms-5";

                    const { column } = cell;
                    const showCursorPointer = ![
                      "select",
                      "task_date",
                      "notes",
                      "customer_display_name",
                      "country_id",
                      "customer_name",
                      "email",
                      "phone",
                      "type",
                      "website",
                      "nature",
                      "customer_group",
                      "deal",
                      "lead",
                    ].includes(cell.column.id);

                    return (
                      <td
                        key={cell.id}
                        className={`group-hover:bg-primary-hover ${selectedRowId?.includes(row.id) ? "bg-[#F0F0F0]" : "bg-white"} whitespace-nowrap border-b border-neutral-200 text-2C495D font-normal text-left text-[12px]  ${showCursorPointer && "cursor-pointer"} 
                              ${cell.column.getIsResizing() ? "border-r !border-r-gray-500 " : "!border-r-transparent"}`}
                        style={{
                          background: cell.getIsGrouped()
                            ? ""
                            : cell.getIsAggregated()
                              ? ""
                              : cell.getIsPlaceholder()
                                ? ""
                                : "",
                          marginLeft: cell.getIsGrouped()
                            ? ""
                            : cell.getIsAggregated()
                              ? ""
                              : cell.getIsPlaceholder()
                                ? "-30px"
                                : "",
                          width: `calc(var(--col-${cell.column.id}-size) * 1px)`,
                          ...getCommonPinningStyles(column, table, noMenuOpenList, defaultPinnedColumn),
                        }}
                        onClick={(e) => SubTaskClick(null, subtask, row.original?.subject)}
                      >
                        <div className={`text-black text-[12px] text-left flex items-center group`}>
                          {isSubjectColumn && (
                            <div className=" ms-3 flex items-center justify-center group-hover:text-primary">
                              <SubTaskIconClosed />
                            </div>
                          )}
                          {/* <div className="flex-1 truncate whitespace-nowrap overflow-hidden text-ellipsis"> */}
                          <div className="flex items-center   text-black min-h-7 w-full  px-3">
                            {flexRender(cell.column.columnDef.cell, subtaskContext)}
                          </div>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              );
            })}

          {/* {row.getIsExpanded() &&
                                  row.subRows.length > 0 &&
                                  row.subRows.map((subRow) => (
                                    <tr key={subRow.id} className="border tablerow border-E1E6EC ">
                                      {subRow.getVisibleCells().map((subCell) => (
                                        <td
                                          key={subCell.id}
                                          className={`whitespace-nowrap border-b    border-neutral-200 text-2C495D font-normal text-left text-[12px] py-0.5`}
                                        >
                                          <div className="ms-5 text-black text-[12px]">
                                            {flexRender(subCell.column.columnDef.cell, subCell.getContext())}
                                          </div>
                                        </td>
                                      ))}
                                    </tr>
                                  ))} */}

          {/* {row.getIsExpanded() && row.subRows.length > 0 && (
          row.subRows.map((subRow) => (
            <tr key={subRow.id} className="border tablerow border-E1E6EC">
              {subRow.getVisibleCells().map((subtaskCell) => (
                <td key={subtaskCell.id} className="border-b px-2 py-1 bg-gray-100">
                  {flexRender(subtaskCell.column.columnDef.cell, subtaskCell.getContext())}
                </td>
              ))}
            </tr>
          ))
        )} */}
        </>
      );
    })}
    {isViewSwitchable && (
      <div
        className={`absolute bottom-12 right-12 ${table.getFilteredRowModel().rows.length > 25 ? "bottom-12" : "bottom-3"}`}
      >
        {compactViewSwitchButton}
      </div>
    )}
  </tbody>
);

export const MemoizedTableBody = React.memo(TableBody, (prev, next) => {
  const prevHeaderSize = prev.table.getHeaderGroups().map((hg) => hg.headers.map((h) => h.getSize()));
  const nextHeaderSize = next.table.getHeaderGroups().map((hg) => hg.headers.map((h) => h.getSize()));

  const isHeaderSame = JSON.stringify(prevHeaderSize) === JSON.stringify(nextHeaderSize);

  // Debug

  return isHeaderSame;
});

const MemoizedFilter = React.memo(Filter);

function IndeterminateCheckbox({ indeterminate, className = "", ...rest }) {
  const ref = React.useRef(null);

  React.useEffect(() => {
    if (typeof indeterminate === "boolean" && ref.current) {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [indeterminate, rest.checked]);

  return <input type="checkbox" ref={ref} className={`${className} cursor-pointer`} {...rest} />;
}

export default CustomerReactTable;
